import { z } from "zod";

export const tool = "ai-gif-generator" as const;
export const frameCostPerGif = 25;
export const maxCharacters = 500;

export const schema = z.object({
  prompt: z
    .string()
    .min(1, "Please enter a prompt")
    .max(maxCharacters, `Prompt must be ${maxCharacters} characters or less`)
    .refine((value) => value.trim().length > 0, "Prompt cannot be empty or contain only spaces"),
});
